var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDouble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.099 5.56l1.05-1.462L22.225 2l-1.05 1.461-8.655 12.065-4.87-4.87-2.541 2.547 6.37 6.37 1.498 1.499 1.237-1.724L24.107 5.56h-.008zM33.841 15.6l1.049-1.461-2.922-2.098-1.05 1.46-13.6 18.96-7.42-7.419-2.54 2.54 1.274 1.275 7.644 7.643L17.774 38l1.237-1.724 14.837-20.682-.007.007z",
    fill: "#fff"
  })));
}
export default SvgCheckDouble;